// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"1e132a70","247":"2bc6186f","453":"ec87a8b1","551":"a20fd97f","627":"1f2b70b2","628":"1c820612","653":"574350e8","678":"26021569","738":"5c1c1b09","768":"d14d2c63","834":"d97717f4","923":"6e3c5636","938":"176e146e"}[chunkId] + ".chunk.js";
};